// extracted by mini-css-extract-plugin
export default {"tips":"hIuz0","tip":"kL902","name":"JfXBg"};